<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Executive</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Search" @keyup="searchit" v-model="search" aria-label="Search">
                    <button class="btn btn-success" @click="newEmployee()">Add New</button>

                    <vue-excel-xlsx
                        :data="employee_mastersExcel"
                        :columns="columns"
                        :filename="'EmployeeData'"
                        :sheetname="'sheetname'"
                        class="btn btn-success"
                        >
                        Excel
                    </vue-excel-xlsx>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>NO</th>
                            <th>UserId</th>
                            <th>Executive Name</th>
                            <th>Mobile</th>
                            <th>Address</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(employee_master,i) in employee_masters.data" :key="employee_master.BANK_ID">
                            <td>{{ i+1 }}</td>
                            <td> {{ employee_master.Employee_User_Id}} </td>
                            <td> {{ employee_master.Employee_First_Name}} {{ employee_master.Employee_Last_Name}} </td>
                            <td>{{ employee_master.Employee_Mobile_Number }}</td>
                            <td>{{ employee_master.Employee_Address }}</td>
                            <td>
                                <a href="#" @click="editEmployeeModel(employee_master)"><i class="fas fa-edit"></i></a>/
                                <a href="#" @click="editPassword(employee_master)"><i class="fas fa-key brown"></i></a>/
                                <a href="#" @click="deleteEmployee(employee_master.EMPLOYEE_ID)"><i class="fas fa-trash-alt red"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="employee_masters" @pagination-change-page="loadAndSearchEmployee" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchEmployee(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
                <!-- Modal -->
            <div class="modal fade" id="employee_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode" id="exampleModalLabel">Add New Executive</h5>
                    <h5 class="modal-title" v-show="editmode" id="exampleModalLabel">UpdateExecutive</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="editmode ? UpdateEmployee() : CreateEmployee()" @keydown="form.onKeydown($event)">
                <div class="modal-body">
                        <div class="form-group">
                            <label>First Name</label>
                            <input v-model="form.Employee_First_Name" type="text" name="Employee_First_Name" @input="GenrateUserId"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Employee_First_Name') }">
                            <has-error :form="form" field="Employee_First_Name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Last Name</label>
                            <input v-model="form.Employee_Last_Name" type="text" name="Employee_Last_Name" @input="GenrateUserId"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Employee_Last_Name') }">
                            <has-error :form="form" field="Employee_Last_Name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Executive Address</label>
                            <textarea v-model="form.Employee_Address" type="text" name="Employee_Address"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Employee_Address') }"></textarea>
                            <has-error :form="form" field="Employee_Address"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Mobile</label>
                            <input v-model="form.Employee_Mobile_Number" type="text" name="Employee_Mobile_Number" @input="GenrateUserId" maxlength="10"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Employee_Mobile_Number') }" >
                            <has-error :form="form" field="Employee_Mobile_Number"></has-error>
                        </div>
                        <div class="form-group">
                            <label>User Id:- {{ form.Employee_User_Id }}</label>
                            <input v-model="form.Employee_User_Id" type="hidden" name="Employee_User_Id"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Employee_User_Id') }">
                            <has-error :form="form" field="Employee_User_Id"></has-error>
                        </div>
                        <div class="form-group" v-if="!editmode">
                            <label>Password:- {{ form.Employee_Password }}</label>
                            <button type="button"  @click="Genratepassword" class="btn btn-warning float-right">Generate</button>
                            <has-error :form="form" field="Employee_Password"></has-error>
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" v-show="!editmode" class="btn btn-primary">Save Executive</button>
                    <button type="submit" v-show="editmode" class="btn btn-success">Update</button>
                </div>
                </form>
                </div>
            </div>
            </div>
            <!--end Model-->
            <!-- Modal -->
            <div class="modal fade" id="employee_change_password_model" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Change Password</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="UpdateEmployeePassword()" @keydown="form.onKeydown($event)">
                <div class="modal-body">
                        <div class="form-group">
                            <label>User Id:- {{ form.Employee_User_Id }}</label>
                            <has-error :form="form" field="Employee_User_Id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Password:- {{ form.Employee_Password }}</label>
                            <button type="button" @click="Genratepassword" class="btn btn-warning float-right">Generate</button>
                            <has-error :form="form" field="Employee_Password"></has-error>
                        </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-success">Update</button>
                </div>
                </form>
                </div>
            </div>
            </div>
            <!--end Model-->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                editmode:false,
                search:'',
                employee_masters:{},
                employee_mastersExcel:[],
                form: new Form({
                    EMPLOYEE_ID:'',
                    Employee_First_Name:'',
                    Employee_Last_Name:'',
                    Employee_User_Id:'',
                    Employee_Password:'',
                    Employee_Mobile_Number:'',
                    Employee_Address:'',
                }),
                columns : [
                    {
                        label: "Employee User Id",
                        field: "Employee_User_Id",
                    },
                    {
                        label: "Employee First Name",
                        field: "Employee_First_Name",
                    },
                    {
                        label: "Employee Last Name",
                        field: "Employee_Last_Name",
                    },
                    {
                        label: "Phone",
                        field: "Employee_Mobile_Number",
                    },
                    {
                        label: "Address",
                        field: "Employee_Address",
                    },
                ],
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchEmployee();
            })
            Fire.$on('AfterChangeEmployee',()=>{
                this.loadAndSearchEmployee();
            });
        },
        mounted(){
            this.loadAndSearchEmployee();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            Genratepassword(){
                let characters = [
                    {
                        name: "Lowercase",
                        value: "abcdefghijklmnopqrstuvwxyz",
                    },
                    {
                        name: "Uppercase",
                        value: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                    },
                    {
                        name: "Numbers",
                        value: "0123456789",
                    },
                ];
                let gLength = 6;
                let result = "";
                let charactersVal = "";
                for (var j = 0; j < characters.length; j++) {
                    charactersVal += characters[j].value;
                }
                for ( var i = 0; i < gLength; i++ ) {
                    result += charactersVal.charAt(Math.floor(Math.random() * charactersVal.length));
                }
                this.form.Employee_Password = result;
            },
            editEmployeeModel(product_master){
                this.editmode = true,
                this.form.reset();
                $('#employee_model').modal('show');
                this.form.fill(product_master);
            },
            GenrateUserId(){
                this.form.Employee_First_Name = this.form.Employee_First_Name.charAt(0).toUpperCase() + this.form.Employee_First_Name.slice(1);
                this.form.Employee_Last_Name = this.form.Employee_Last_Name.charAt(0).toUpperCase() + this.form.Employee_Last_Name.slice(1);

                    if(this.form.Employee_First_Name.length >=3 && this.form.Employee_Mobile_Number.length >=10){
                        if(this.form.Employee_First_Name.length){ this.Genratepassword(); } //if all three fileds are fill then generate password
                        this.form.Employee_User_Id = this.form.Employee_First_Name.substring(0,3) + this.form.Employee_Mobile_Number.substring(0,4)
                    } else {
                        this.form.Employee_User_Id = '';
                    }

            },
            UpdateEmployeePassword(){
                this.toast.$emit("LoadingOn");
                this.form.put('changePasswordEmployee/'+this.form.EMPLOYEE_ID)

                .then(()=> {
                    Fire.$emit('AfterChangeEmployee');
                    $('#employee_change_password_model').modal('hide');
                    this.toast.$emit('LoadingOffSuccess', "Password Updated successfully");
                })
                .catch(()=> {
                    this.toast.$emit('LoadingOffError', "your request could not be processed.");
                })
            },
            editPassword(employee_master){
                this.editmode = true,
                this.form.reset();
                $('#employee_change_password_model').modal('show');
                this.form.fill(employee_master);
                this.form.Employee_Password = '';
            },
            newEmployee(){
                this.editmode = false,
                this.form.reset();
                $('#employee_model').modal('show');
            },
            deleteEmployee(EMPLOYEE_ID){
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if(result.value){
                            this.form.delete('employee_master/'+EMPLOYEE_ID).then(()=>{
                                Fire.$emit('AfterChangeEmployee');
                                this.toast.$emit('SwalSuccess',"Deleted!", "Employee Deleted.");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Employee Is Already In Use");
                            })
                        }
                    })
            },
            CreateEmployee(){
                this.toast.$emit("LoadingOn");
                this.form.post('employee_master')
                .then(()=>{
                    $('#employee_model').modal('hide')
                    // this.loadAndSearchEmployee();
                    Fire.$emit('AfterChangeEmployee');
                    this.toast.$emit('LoadingOffSuccess', "Employee Create successfully");

                })
                .catch(()=>{
                    this.toast.$emit('LoadingOffError', "your Request Failed.");
                })
            },
            UpdateEmployee(){
                this.toast.$emit("LoadingOn");
                this.form.put('employee_master/'+this.form.EMPLOYEE_ID)
                .then(()=>{
                    $('#employee_model').modal('hide')
                    // this.loadAndSearchEmployee();
                    Fire.$emit('AfterChangeEmployee');
                    this.toast.$emit('LoadingOffSuccess', "Employee Update successfully");

                })
                .catch(()=>{
                    this.toast.$emit('LoadingOffError', "your Request Failed.");
                })
            },
            loadAndSearchEmployee(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchEmployee?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.employee_masters = data,
                        this.toast.$emit('ProgressBarFinish'),
                        this.loadAndSearchEmployeeExcel()
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
            loadAndSearchEmployeeExcel(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchEmployeeExcel?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.employee_mastersExcel = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
